export default {
    CATEGORIES_FETCH: 'FETCH_CATEGORIES',
    CATEGORIES_SET: 'CATEGORIES_SET'
}